<svg
  width="15"
  height="14"
  viewBox="0 0 15 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
>
  <line x1="0.646447" y1="13.6464" x2="13.6464" y2="0.646446" stroke="black" />
  <line
    y1="-0.5"
    x2="18.3848"
    y2="-0.5"
    transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14 14)"
    stroke="black"
  />
</svg>
